let elements = {
  mainImage: {
    imagePath: 'games/page001_game2/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  fields: [
    {
      pos: {
        y: 322,
        x: 114,
      },
      width: 690,
      height: 610,
      background: 'transparent',
      audio: {
        src: 'games/page001_game2/audio/fls.mp3',
        volume: 1,
      },
      text: {
        // text: 'Zachowuj porządek podczas pracy przy komputerze.',
        pos: {
          y: 202,
          x: 305,
        },
        width: 176,
        height: 176,
        background: 'url(' + require('./img/false.png') + ')',
        // cssStyle: { 'border-radius': '30px', border: 'solid 5px #3a5f8b' },
      },
    },
    {
      pos: {
        y: 322,
        x: 982,
      },
      width: 690,
      height: 610,
      background: 'transparent',
      audio: {
        src: 'games/page001_game2/audio/tru.mp3',
        volume: 1,
      },
      text: {
        // text: 'Zachowuj porządek podczas pracy przy komputerze.',
        pos: {
          y: 202,
          x: 1175,
        },
        width: 176,
        height: 176,
        background: 'url(' + require('./img/true.png') + ')',
        // cssStyle: { 'border-radius': '30px', border: 'solid 5px #3a5f8b' },
      },
    },
  ],
  // mbAudioItemData: [
  //   {
  //     src: 'games/page001_game3/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 223,
  //       x: 464,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page001_game3/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 512,
  //       x: 574,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page001_game3/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 333,
  //       x: 1344,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page001_game3/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 773,
  //       x: 1214,
  //     },
  //     unit: 'px',
  //   },
  // ],
};

export default elements;
